/**
 * @typedef module:Media.SocketStateEnum
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/readyState}
 * @description Enum for WebSocket connection state
 * @property {Number} connecting 0 - Socket has been created. The connection is not yet open.
 * @property {Number} open 1 - The connection is open and ready to communicate.
 * @property {Number} closing 2 - The connection is in the process of closing.
 * @property {Number} closed 3 - The connection is closed or couldn't be opened.
 */

const SocketStateEnum = Object.freeze({
    connecting: 0,
    open: 1,
    closing: 2,
    closed: 3
});

export default SocketStateEnum;
